/* 🤖 this file was generated by svg-to-ts */
export const matIconViewSidebar: {
  name: 'view-sidebar';
  data: string;
} = {
  name: 'view-sidebar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 4v16h20V4H2zm18 4.67h-2.5V6H20v2.67zm-2.5 2H20v2.67h-2.5v-2.67zM4 6h11.5v12H4V6zm13.5 12v-2.67H20V18h-2.5z"/></svg>`
};
